export const PostMessages = {
  VEHICLE_TRANSFERRED: 'VEHICLE_TRANSFERRED',
};

const ALLOWED_ORIGINS = [
  'http://localhost:3000',
  'http://localhost:4000',
  'https://web.soon.com.vc',
  'https://homologacao.soon.com.vc',
];

/**
 * Valida se a origem da mensagem é confiável
 * @param {string} origin - Origem da mensagem
 * @returns {boolean} - Se a origem é válida
 */
function isValidOrigin(origin) {
  return ALLOWED_ORIGINS.includes(origin);
}

/**
 * Adiciona um listener para mensagens vindas do AdminV2
 *
 * @param {PostMessages} type - Tipo da mensagem a escutar
 * @param {function} handler - Função a ser chamada com o payload
 * @returns {function} - Função para remover o listener
 */
export function postMessageListener(type, handler) {
  if (!type || typeof handler !== 'function') return () => {};

  function listener(event) {
    try {
      if (!isValidOrigin(event.origin)) return;

      if (!event.data) return;

      const {type: messageType, payload} = event.data;

      if (messageType === type) {
        handler(payload);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('[PostMessage] Erro ao processar mensagem:', error);
      }
    }
  }

  window.addEventListener('message', listener);

  return function removeListener() {
    window.removeEventListener('message', listener);
  };
}

/**
 * Envia mensagem para o AdminV2 (quando AdminV1 está em iframe)
 * @param {PostMessages} type - Tipo da mensagem
 * @param {object} payload - Dados da mensagem
 */
export function postMessageEmitter(type, payload) {
  try {
    if (!window.parent || window.parent === window) return;

    const message = {type, payload};

    const currentOrigin = window.location.origin;
    window.parent.postMessage(message, currentOrigin);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[PostMessage] Erro ao enviar mensagem:', error);
    }
  }
}
